import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ViewModal = ({ open, onClose, amendment, type }) => {
  if (!amendment) return null;

  const content = type === 'reason' ? amendment.reason : amendment.reviewerNotes;
  const title = type === 'reason' ? 'Amendment Reason' : 'Reviewer Notes';

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 1,
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        }
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: '#fff',
          color: '#00694B',
          p: 2,
          fontSize: '1.5rem',
          fontWeight: 500,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          // borderBottom: '1px solid #e0e0e0'
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: '#000',
            '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.04)' }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
          {content || 'N/A'}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            bgcolor: '#00694B',
            color: '#fff',
            '&:hover': { bgcolor: '#005039' },
            textTransform: 'none',
            borderRadius: 3,
            px: 4,
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '24px'
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewModal;
